import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll";
import { elastic as Menu } from "react-burger-menu";
// import { Avatar, Options } from 'react-avataaars';
import Avatar from "avataaars";
import { URLBunge } from "./Componentes/Config";
import {
  AlertForm,
  maskLoginSympla,
  MostrarIngresso,
  hexToRgbA,
  LogAcesso,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import Rodape from "./Componentes/Rodape";
import MenuPrinc from "./Componentes/MenuPrinc";
import Draggable from "react-draggable";

import {
  Clear,
  BackgroundImg,
  Coluna,
  ColunaAvatar,
  BgAvatarHome,
  MapaHome,
  TopoHome,
  BtMapa,
  BtsRankingMoedas,
  BtNovoEvento,
  ModalEvento,
  BtRankingMoedas,
  BgModal,
  CaminhoPesquisas,
  MetaDiaria,
  QntPesquisasRealizadas,
  BtNovaPesquisa,
  BtPassos,

  // MenuPrinc,
  BtMenuPesquisas,
  BtMenuNoticias,
  BtMenuRelatorio,
  BtMenuConteudos,
  BtMenuRegras,
} from "./Estilos";

import ImgMapa from "./Images/BgMapa_v5.jpg";
import BgCaminhoPesquisas from "./Images/BgGranularClassico.jpg";

import ImgBtIndireto from "./Images/Bt_Indireto.png";
import ImgBtGranularClassico from "./Images/Bt_GranularClassico.png";
import ImgBtAcademiaBunge from "./Images/Bt_AcademiaBunge.png";
import ImgBtFornadaDeVantagens from "./Images/Bt_FornadaDeVantagens.png";
import ImgBtEcommerce from "./Images/Bt_Ecommerce.png";
import ImgBtOmnichannel from "./Images/Bt_Omnichannel.png";
import ImgBtPesquisaExtra from "./Images/Bt_PesquisaExtra.png";
import ImgBtMoedas from "./Images/ico_moedas.png";
import ImgBtRanking from "./Images/ico_ranking.png";
import ImgBtMoedasRanking from "./Images/ico_bt_moedas_ranking.png";
import ImgBtDesafio1500 from "./Images/Bt_Recompra1500Bonificacao.png";
import ImgBtPotencialCompra from "./Images/Bt_PotencialCompra.png";
import ImgBtMerchandising from "./Images/Bt_Merchandising.png";
import ImgBtPortalVendedor from "./Images/Bt_PortalDoVendedor.png";

import BtPasso1 from "./Images/bt_passo1.png";
import BtPasso1Ativo from "./Images/bt_passo1_ativo.png";

import BtPasso2 from "./Images/bt_passo2.png";
import BtPasso2Ativo from "./Images/bt_passo2_ativo.png";

import BtPasso3 from "./Images/bt_passo3.png";
import BtPasso3Ativo from "./Images/bt_passo3_ativo.png";

import BtPasso4 from "./Images/bt_passo4.png";
import BtPasso4Ativo from "./Images/bt_passo4_ativo.png";

import BtPasso5 from "./Images/bt_passo5.png";
import BtPasso5Ativo from "./Images/bt_passo5_ativo.png";

import BtPasso6 from "./Images/bt_passo6.png";
import BtPasso6Ativo from "./Images/bt_passo6_ativo.png";

const MENSAGENS_TESTE = [
  {PushId: 15, message: 'Bom dia, essa mensagem é apenas um teste. pushId 15', title: 'Filtro de Clientes, PushId: 15'},
  {PushId: 23, message: 'Boa tarde, essa mensagem é apenas um teste. pushId 23', title: 'Filtro de Clientes, PushId: 23'},
  {PushId: 20, message: 'Bom feriado, essa mensagem é apenas um teste. pushId 20', title: 'Filtro de Clientes, PushId: 20'},
  {PushId: 24, message: 'Bom final de semana, essa mensagem é apenas um teste. pushId 24', title: 'Filtro de Clientes, PushId: 24'},
];

function Home(props) {
  const history = useHistory();
  
  const [imgMapWidth, setImgMapWidth] = useState(0);
  const [imgMapHeight, setImgMapHeight] = useState(0);
  const [Loading, setLoading] = useState(false);

  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [NomeUsuario, setNomeUsuario] = useState(
    localStorage.getItem("c_nome")
  );
  const [EmailUsuario, setEmailUsuario] = useState(
    localStorage.getItem("c_email")
  );
  const [IdUsuario, setIdUsuario] = useState(
    localStorage.getItem("id_tb_user")
  );
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [Tipo, setTipo] = useState(localStorage.getItem("c_tipo"));
  const [Cargo, setCargo] = useState(localStorage.getItem("c_cargo"));

  const [Avatar_topType, setAvatar_topType] = useState(
    localStorage.getItem("c_avatar_topType")
  );
  const [Avatar_accessoriesType, setAvatar_accessoriesType] = useState(
    localStorage.getItem("c_avatar_accessoriesType")
  );
  const [Avatar_hatColor, setAvatar_hatColor] = useState(
    localStorage.getItem("c_avatar_hatColor")
  );
  const [Avatar_hairColor, setAvatar_hairColor] = useState(
    localStorage.getItem("c_avatar_hairColor")
  );
  const [Avatar_facialHairType, setAvatar_facialHairType] = useState(
    localStorage.getItem("c_avatar_facialHairType")
  );
  const [Avatar_facialHairColor, setAvatar_facialHairColor] = useState(
    localStorage.getItem("c_avatar_facialHairColor")
  );
  const [Avatar_clotheType, setAvatar_clotheType] = useState(
    localStorage.getItem("c_avatar_clotheType")
  );
  const [Avatar_clotheColor, setAvatar_clotheColor] = useState(
    localStorage.getItem("c_avatar_clotheColor")
  );
  const [Avatar_graphicType, setAvatar_graphicType] = useState(
    localStorage.getItem("c_avatar_graphicType")
  );
  const [Avatar_eyeType, setAvatar_eyeType] = useState(
    localStorage.getItem("c_avatar_eyeType")
  );
  const [Avatar_eyebrowType, setAvatar_eyebrowType] = useState(
    localStorage.getItem("c_avatar_eyebrowType")
  );
  const [Avatar_mouthType, setAvatar_mouthType] = useState(
    localStorage.getItem("c_avatar_mouthType")
  );
  const [Avatar_skinColor, setAvatar_skinColor] = useState(
    localStorage.getItem("c_avatar_skinColor")
  );
  const [SaldoAtual, setSaldoAtual] = useState(
    localStorage.getItem("c_saldo_atual")
  );
  const [NovoEvento, setNovoEvento] = useState(false);
  const [NovoEventoTitulo, setNovoEventoTitulo] = useState("");
  const [NovoEventoDescricao, setNovoEventoDescricao] = useState("");
  const [NovoEventoTexto, setNovoEventoTexto] = useState("");
  const [RankingAtual, setRankingAtual] = useState(
    localStorage.getItem("c_ranking_atual")
  );
  const [LiberaOmnichannel, setLiberaOmnichannel] = useState(false);
  const [LiberaEcommerce, setLiberaEcommerce] = useState(false);
  const [LiberaFornada, setLiberaFornada] = useState(false);
  const [LiberaPortalVendedor, setLiberaPortalVendedor] = useState(false);
  const [LiberaBonificacao1500, setLiberaBonificacao1500] = useState(false);

  const [TipoModalGranularIndireto, setTipoModalGranularIndireto] = useState(0);
  const [MetaPesquisas, setMetaPesquisas] = useState(0);
  const [PesquisasRealizadas, setPesquisasRealizadas] = useState(0);
  const [TextoQntPesquisas, setTextoQntPesquisas] = useState("");
  const [MostraNovoEvento, setMostraNovoEvento] = useState(false);
  const [LinkAcademia, setLinkAcademia] = useState("AcademiaBunge");
  const [MostraGranularIndireto, setMostraGranularIndireto] = useState(false);
  const [LiberaPotencialCompra, setLiberaPotencialCompra] = useState(false);
  const [CargosTrade, setCargosTrade] = useState([
    "2774",
    "2820",
    "2821",
    "2822",
    "2773",
  ]);

  useEffect(() => {
    if (Token === null) {
      history.push({ pathname: "/", state: {} });
    } else {
      PegaSaldo();
      PegaRanking();
      PegaNoticiasEvento();
      PegaAvatar();
      LogAcesso(Token, "Home");
      document.body.classList.add("RemoveScroll");
    }
    // console.log(Token);
  }, []);

  async function PegaSaldo() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + Token);

    const Saldo = await fetch(URLBunge + "/api/Saldo/Busca", {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    });

    const resultSaldo = await Saldo.json();
    if (resultSaldo.sucesso === true) {
      localStorage.setItem(
        "c_saldo_atual",
        resultSaldo.saldoAtual.toLocaleString()
      );
      setSaldoAtual(resultSaldo.saldoAtual.toLocaleString());
    }
  }

  async function PegaRanking() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + Token);

    const ListarTrimestral = await fetch(
      URLBunge + "/api/Ranking/ListarTrimestral",
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({}),
        redirect: "follow",
      }
    );

    const resultListarTrimestral = await ListarTrimestral.json();
    if (resultListarTrimestral.sucesso === true) {
      localStorage.setItem(
        "c_ranking_atual",
        resultListarTrimestral.posicaoAtual.toLocaleString()
      );
      setRankingAtual(resultListarTrimestral.posicaoAtual.toLocaleString());
    }
  }

  async function PegaNoticiasEvento() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(URLBunge + "/api/Noticias/NoticiasEvento", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log('NoticiasEvento', result);
        if (result.sucesso === true) {
          setNovoEvento(result.sucesso);
          setNovoEventoTitulo(result.titulo);
          setNovoEventoDescricao(result.descricao);
          setNovoEventoTexto(result.texto);
        }
      })
      .catch((error) => console.log("errorx", error));
  }

  async function PegaAvatar() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    fetch(URLBunge + "/api/Cliente/ListarClienteDoc", {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        localStorage.setItem("c_avatar_topType", result.avatar[0].produto);
        localStorage.setItem(
          "c_avatar_accessoriesType",
          result.avatar[1].produto
        );
        localStorage.setItem("c_avatar_hatColor", result.avatar[2].produto);
        localStorage.setItem("c_avatar_hairColor", result.avatar[3].produto);
        localStorage.setItem(
          "c_avatar_facialHairType",
          result.avatar[4].produto
        );
        localStorage.setItem(
          "c_avatar_facialHairColor",
          result.avatar[5].produto
        );
        localStorage.setItem("c_avatar_clotheType", result.avatar[6].produto);
        localStorage.setItem("c_avatar_clotheColor", result.avatar[7].produto);
        localStorage.setItem("c_avatar_graphicType", result.avatar[8].produto);
        localStorage.setItem("c_avatar_eyeType", result.avatar[9].produto);
        localStorage.setItem("c_avatar_eyebrowType", result.avatar[10].produto);
        localStorage.setItem("c_avatar_mouthType", result.avatar[11].produto);
        localStorage.setItem("c_avatar_skinColor", result.avatar[12].produto);
      })
      .catch((error) => console.log("error", error));
  }

  function LogOut() {
    setLoading(true);

    setTimeout(() => {
      setNomeUsuario("");
      setEmailUsuario("");
      setIdUsuario("");
      setToken("");
      localStorage.removeItem("c_nome");
      localStorage.removeItem("c_email");
      localStorage.removeItem("c_id");
      localStorage.removeItem("c_token");
      history.push({ pathname: "login", state: {} });
    }, 500);
  }

  const MostrarEvento = (props) => {
    return (
      <>
        <BgModal>
          <ModalEvento>
            <div className={"TextoEvento"}>
              <div className={"TituloEvento"}>{NovoEventoDescricao}</div>
              {NovoEventoTexto}

              {/* OBS: VALORES TEMPORÁRIOS, REMOVER APÓS OS TESTES E APIS IMPLEMENTADA. */}
              {/* {MENSAGENS_TESTE.map((msg, index) => (
                <div key={index} style={{  marginTop: '15px' }}>
                  <span
                    style={{
                      colo: '#333333',
                      textDecoration: 'underline',
                      fontSize: '15px',
                      marginBottom: '10px',
                      cursor: 'pointer',
                    }} 
                    onClick={() => history.push({ pathname: "FiltroPush", state: {PushId: msg.PushId, message: msg.message, title: msg.title} })}
                  >
                    {msg.message}
                  </span>
                </div>
              ))} */}
            </div>
            <a
              className={"BtFecharModal"}
              onClick={() => setMostraNovoEvento(false)}
            >
              FECHAR
            </a>
          </ModalEvento>
        </BgModal>
      </>
    );
  };

  function PegaDados(tipo) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Pesquisa/InfoPesquisa/` + tipo, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setMetaPesquisas(result.qtdPesquisaMeta);
        setPesquisasRealizadas(result.qtdPesquisaRespondida);
      })
      .catch((error) => console.log("error", error));
  }

  function QntPesquisas() {
    switch (PesquisasRealizadas) {
      case 0:
        setTextoQntPesquisas("Nenhuma pesquisa realizada hoje");
        break;
      case 1:
        setTextoQntPesquisas("1 pesquisa realizada hoje");
        break;
      default:
        setTextoQntPesquisas(
          PesquisasRealizadas + " pesquisas realizadas hoje"
        );
        break;
    }
  }

  useEffect(() => {
    QntPesquisas();
  }, [PesquisasRealizadas]);

  function AbreModalGranularIndireto(tipo) {
    setMostraGranularIndireto(true);
    PegaDados(tipo);
    setTipoModalGranularIndireto(tipo);
  }

  function FechaModalGranularIndireto() {
    setMostraGranularIndireto(false);
    setTextoQntPesquisas("");
    setMetaPesquisas(0);
  }

  const MostrarGranularIndireto = (props) => {
    return (
      <>
        <BgModal>
          <CaminhoPesquisas>
            <div className={"TextoEvento"}>
              <div className={"TituloEvento"}>
                {TipoModalGranularIndireto == 1
                  ? "Granular e Clássico"
                  : "Indireto"}
              </div>
              <MetaDiaria>
                {" "}
                <div>
                  meta
                  <br />
                  diária
                </div>{" "}
                <div>{MetaPesquisas}</div>{" "}
              </MetaDiaria>

              <BtPassos
                BgPasso={PesquisasRealizadas >= 1 ? BtPasso1Ativo : BtPasso1}
                Top={3}
                Left={60}
                onClick={
                  PesquisasRealizadas >= 1
                    ? null
                    : () =>
                        TipoModalGranularIndireto == 1
                          ? history.push({
                              pathname: "/GranularClassicoPesquisa",
                              state: {},
                            })
                          : history.push({
                              pathname: "/IndiretoPesquisa",
                              state: {},
                            })
                }
              />

              <BtPassos
                BgPasso={PesquisasRealizadas >= 2 ? BtPasso2Ativo : BtPasso2}
                Top={12}
                Left={28}
                onClick={
                  PesquisasRealizadas >= 2
                    ? null
                    : () =>
                        TipoModalGranularIndireto == 1
                          ? history.push({
                              pathname: "/GranularClassicoPesquisa",
                              state: {},
                            })
                          : history.push({
                              pathname: "/IndiretoPesquisa",
                              state: {},
                            })
                }
              />

              <BtPassos
                BgPasso={PesquisasRealizadas >= 3 ? BtPasso3Ativo : BtPasso3}
                Top={25}
                Left={50}
                onClick={
                  PesquisasRealizadas >= 3
                    ? null
                    : () =>
                        TipoModalGranularIndireto == 1
                          ? history.push({
                              pathname: "/GranularClassicoPesquisa",
                              state: {},
                            })
                          : history.push({
                              pathname: "/IndiretoPesquisa",
                              state: {},
                            })
                }
              />

              <BtPassos
                BgPasso={PesquisasRealizadas >= 4 ? BtPasso4Ativo : BtPasso4}
                Top={28}
                Left={5}
                onClick={
                  PesquisasRealizadas >= 4
                    ? null
                    : () =>
                        TipoModalGranularIndireto == 1
                          ? history.push({
                              pathname: "/GranularClassicoPesquisa",
                              state: {},
                            })
                          : history.push({
                              pathname: "/IndiretoPesquisa",
                              state: {},
                            })
                }
              />

              {TipoModalGranularIndireto == 1 ? (
                <>
                  <BtPassos
                    BgPasso={
                      PesquisasRealizadas >= 5 ? BtPasso5Ativo : BtPasso5
                    }
                    Top={35}
                    Left={35}
                    onClick={
                      PesquisasRealizadas >= 5
                        ? null
                        : () =>
                            TipoModalGranularIndireto == 1
                              ? history.push({
                                  pathname: "/GranularClassicoPesquisa",
                                  state: {},
                                })
                              : history.push({
                                  pathname: "/IndiretoPesquisa",
                                  state: {},
                                })
                    }
                  />

                  <BtPassos
                    BgPasso={
                      PesquisasRealizadas >= 6 ? BtPasso6Ativo : BtPasso6
                    }
                    Top={42}
                    Left={55}
                    onClick={
                      PesquisasRealizadas >= 6
                        ? null
                        : () =>
                            TipoModalGranularIndireto == 1
                              ? history.push({
                                  pathname: "/GranularClassicoPesquisa",
                                  state: {},
                                })
                              : history.push({
                                  pathname: "/IndiretoPesquisa",
                                  state: {},
                                })
                    }
                  />
                </>
              ) : null}

              <BtNovaPesquisa
                onClick={() =>
                  TipoModalGranularIndireto == 1
                    ? history.push({
                        pathname: "/GranularClassicoPesquisa",
                        state: {},
                      })
                    : history.push({ pathname: "/IndiretoPesquisa", state: {} })
                }
              >
                FAZER NOVA PESQUISA
                <br />/ ACOMPANHAMENTO
              </BtNovaPesquisa>
              <QntPesquisasRealizadas>
                {TextoQntPesquisas}
              </QntPesquisasRealizadas>
              <a
                className={"BtFecharModal"}
                onClick={() => FechaModalGranularIndireto()}
              >
                FECHAR
              </a>
            </div>
          </CaminhoPesquisas>
        </BgModal>
      </>
    );
  };

  useEffect(() => {
    if (Cargo !== "2653" && Cargo !== "2661") {
      setLinkAcademia("AcademiaBunge");
    }
    if (Cargo == "2653") {
      setLinkAcademia("AcademiaFormularioCalendario");
    }
    if (Cargo == "2661") {
      setLinkAcademia("AcademiaFormularioListaTecnico");
    }
    VerificaAtivo();
    const imgMap = document.getElementById("imgmap");
    if (imgMap) {
      const width = imgMap.clientWidth;
      const height = imgMap.clientHeight;
      setImgMapWidth(width);
      setImgMapHeight(height);
      // console.log("***", width, height);
    }
  }, []);

  const VerificaAtivo = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    fetch(`${URLBunge}/api/Pesquisa/ListarTipoPesquisas`, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((result) => {
        try {
          setLiberaPotencialCompra(
            result.listaTipoPesquisas.find((a) => a.id === 5).ativa
          );
        } catch (error) {}
        try {
          setLiberaOmnichannel(
            result.listaTipoPesquisas.find((a) => a.id === 8).ativa
          );
        } catch (error) {}
        try {
          setLiberaEcommerce(
            result.listaTipoPesquisas.find((a) => a.id === 9).ativa
          );
        } catch (error) {}
        try {
          setLiberaFornada(
            result.listaTipoPesquisas.find((a) => a.id === 10).ativa
          );
        } catch (error) {}
        try {
          setLiberaPortalVendedor(
            result.listaTipoPesquisas.find((a) => a.id === 11).ativa
          );
        } catch (error) {}
        try {
          setLiberaBonificacao1500(
            result.listaTipoPesquisas.find((a) => a.id === 12).ativa
          );
        } catch (error) {}
      })
      .catch((error) => console.log("error", error));
  };


  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      {MostraNovoEvento === true ? <MostrarEvento /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#e7e097"}>
        {MostraGranularIndireto === true ? <MostrarGranularIndireto /> : null}

        <TopoHome>
          <ColunaAvatar>
            <BgAvatarHome
              onClick={() => history.push({ pathname: "/perfil", state: {} })}
            >
              <Avatar
                style={{ width: "120px", height: "120px" }}
                avatarStyle="Transparent"
                topType={Avatar_topType}
                accessoriesType={Avatar_accessoriesType}
                hatColor={Avatar_hatColor}
                hairColor={Avatar_hairColor}
                facialHairType={Avatar_facialHairType}
                facialHairColor={Avatar_facialHairColor}
                clotheType={Avatar_clotheType}
                clotheColor={Avatar_clotheColor}
                graphicType={Avatar_graphicType}
                eyeType={Avatar_eyeType}
                eyebrowType={Avatar_eyebrowType}
                mouthType={Avatar_mouthType}
                skinColor={Avatar_skinColor}
              />
            </BgAvatarHome>

            <BtsRankingMoedas>
              {/* <div onClick={()=>LogOut()}>SAIR</div> */}
              {Cargo !== "2653" &&
              Cargo !== "2661" &&
              !CargosTrade.includes(Cargo) ? (
                <>
                  {/* <BtRankingMoedas
                    onClick={() =>
                      history.push({ pathname: "/ranking", state: {} })
                    }
                  >
                    {" "}
                    <span>
                      {" "}
                      <img src={ImgBtRanking} /> <span>Ranking</span>{" "}
                      {RankingAtual == null ? 1 : RankingAtual.toLocaleString()}
                      º{" "}
                    </span>{" "}
                    <img src={ImgBtMoedasRanking} />{" "}
                  </BtRankingMoedas> */}
                  <BtRankingMoedas
                    onClick={() =>
                      history.push({ pathname: "/lojinha", state: {} })
                    }
                  >
                    {" "}
                    <span>
                      {" "}
                      <img src={ImgBtMoedas} /> <span>Moedas</span>{" "}
                      {SaldoAtual == null ? 0 : SaldoAtual.toLocaleString()}{" "}
                    </span>{" "}
                    <img src={ImgBtMoedasRanking} />{" "}
                  </BtRankingMoedas>
                </>
              ) : null}
            </BtsRankingMoedas>

            <div>
              {NovoEvento === true ? (
                <BtNovoEvento onClick={() => setMostraNovoEvento(true)}>
                  <div>{NovoEventoTitulo}</div>
                </BtNovoEvento>
              ) : null}
            </div>
          </ColunaAvatar>
        </TopoHome>

        <Draggable
          // axis="both"
          // bounds={{
          //   left: 0,
          //   right: 0,
          //   top: 0,
          //   bottom: 2000,
          // }}
          cancel=".btn"
        >
          <MapaHome id="imgmap" src={ImgMapa}>
            {Tipo !== "2479" ? (
              <BtMapa
                top={37}
                left={5}
                src={ImgBtMerchandising}
                onClick={() =>
                  history.push({ pathname: "/Merchandising", state: {} })
                }
              />
            ) : null}
            {LiberaPotencialCompra === true ? (
              Cargo !== "2653" && Cargo !== "2661" ? (
                <BtMapa
                  top={45}
                  left={61}
                  src={ImgBtPotencialCompra}
                  onClick={() =>
                    history.push({ pathname: "/PotencialCompra", state: {} })
                  }
                />
              ) : null
            ) : null}
            {LiberaBonificacao1500 ? (
              Cargo !== "2653" && Cargo !== "2661" ? (
                <BtMapa
                  top={36}
                  left={77}
                  src={ImgBtDesafio1500}
                  onClick={() =>
                    history.push({
                      pathname: "/BonificacaoeRecompra1500",
                      state: {},
                    })
                  }
                />
              ) : null
            ) : null}
            {Cargo !== "2653" && Cargo !== "2661" ? (
              Tipo == "7" || Tipo == "2479" ? (
                <BtMapa
                  top={47}
                  left={25.5}
                  src={ImgBtGranularClassico}
                  onClick={() => AbreModalGranularIndireto(1)}
                />
              ) : null
            ) : null}
            {Cargo !== "2653" && Cargo !== "2661" ? (
              Tipo == "7" || Tipo == "2277" ? (
                <BtMapa
                  top={26}
                  left={18}
                  src={ImgBtIndireto}
                  onClick={() => AbreModalGranularIndireto(2)}
                />
              ) : null
            ) : null}
            {LiberaFornada ? (
              Cargo !== "2653" && Cargo !== "2661" ? (
                Tipo == "7" || Tipo == "2479" ? (
                  <BtMapa
                    top={15}
                    left={49}
                    src={ImgBtFornadaDeVantagens}
                    onClick={() =>
                      history.push({
                        pathname: "/FornadaDeVantagens",
                        state: {},
                      })
                    }
                  />
                ) : null
              ) : null
            ) : null}
            {LiberaEcommerce ? (
              Cargo !== "2653" && Cargo !== "2661" ? (
                <BtMapa
                  top={65}
                  left={42.5}
                  src={ImgBtEcommerce}
                  onClick={() =>
                    history.push({ pathname: "/Ecommerce", state: {} })
                  }
                />
              ) : null
            ) : null}
            {Tipo == "7" || Tipo == "2479" ? (
              <BtMapa
                top={28}
                left={60}
                src={ImgBtAcademiaBunge}
                onClick={() =>
                  history.push({ pathname: LinkAcademia, state: {} })
                }
              />
            ) : null}
            {LiberaOmnichannel ? (
              Cargo !== "2653" && Cargo !== "2661" ? (
                <BtMapa
                  top={57}
                  left={77}
                  src={ImgBtOmnichannel}
                  onClick={() =>
                    history.push({ pathname: "/Omnichannel", state: {} })
                  }
                />
              ) : null
            ) : null}
            {Cargo !== "2653" && Cargo !== "2661" ? (
              <BtMapa
                top={41}
                left={47}
                src={ImgBtPesquisaExtra}
                onClick={() =>
                  history.push({ pathname: "/pesquisaextra", state: {} })
                }
              />
            ) : null}
            {/* {Cargo !== "2653" && Cargo !== "2661" ? ( */}
              {/* <BtMapa
                top={8}
                left={76}
                src={ImgBtPortalVendedor}
                onClick={() =>
                  history.push({ pathname: "/ConsultarCadastros", state: {} })
                }
              /> */}
            {/* ) : null} */}
          </MapaHome>
        </Draggable>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default Home;
